const VIEW_BY_ACCOUNT = 'account';

/**
 * Get display item base on view by
 * - viewBy: account -> displayItem = itemAlias (item)
 * - viewBy: product -> displayItem = itemAlias
 * - viewBy: region -> displayItem = itemAlias
 *
 * @param item
 * @param viewBy
 */
function getDisplayItemBaseOnViewBy(item, viewBy) {
  if (viewBy === VIEW_BY_ACCOUNT) {
    return `${item.itemAlias? item.itemAlias: item.item}(${item.item})`
  }

  return `${item.itemAlias ? item.itemAlias : item.item}`
}

function getDisplayItemBaseOnPortionViewBy(item, viewBy) {
  return `${getDisplayItemBaseOnViewBy(item, viewBy).replace("(","\n(")}`
}

/**
 * Get display item with vendor base on view by
 *
 * @param item
 * @param viewBy
 */
function getDisplayItemWithVendorBaseOnViewBy(item, viewBy) {
  return `${item.vendor} ${getDisplayItemBaseOnViewBy(item, viewBy)}`;
}

function getDisplayCompareItemWithVendorBaseOnViewBy(item, viewBy, compareLabel) {
  return `${item.vendor} ${getDisplayItemBaseOnViewBy(item, viewBy)} ${compareLabel}`;
}

function getDisplayProductPortionBaseOnProductFamily(item){

  if(item.includes("&")){
    return item.replace("&","\n&");
  }else{
    return item;
  }

}

export {
  getDisplayCompareItemWithVendorBaseOnViewBy,
  getDisplayItemBaseOnViewBy,
  getDisplayItemWithVendorBaseOnViewBy,
  getDisplayProductPortionBaseOnProductFamily,
  getDisplayItemBaseOnPortionViewBy
};



// WEBPACK FOOTER //
// ./src/util/formatAccountUtils.js